var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    [
      _c(
        "action-header",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasTarget,
              expression: "hasTarget"
            }
          ],
          attrs: { slot: "header" },
          slot: "header"
        },
        [
          _c("span", { staticClass: "title" }, [
            _c("span", { staticClass: "title-bracket" }, [_vm._v("<")]),
            _c("span", [_vm._v(_vm._s(_vm.targetName))]),
            _c("span", { staticClass: "title-bracket" }, [_vm._v(">")])
          ]),
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("VueIcon", { attrs: { icon: "search" } }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.filter,
                    expression: "filter",
                    modifiers: { trim: true }
                  }
                ],
                attrs: { placeholder: "Filter inspected data" },
                domProps: { value: _vm.filter },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filter = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ],
            1
          ),
          _vm.loading
            ? _c("VueLoadingIndicator", { staticClass: "primary" })
            : _vm._e(),
          _vm.$isChrome
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Inspect DOM",
                      expression: "'Inspect DOM'"
                    }
                  ],
                  staticClass: "button inspect",
                  on: { click: _vm.inspectDOM }
                },
                [
                  _c("VueIcon", { attrs: { icon: "code" } }),
                  _c("span", [_vm._v("Inspect DOM")])
                ],
                1
              )
            : _vm._e(),
          _vm.fileIsPath
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$t("ComponentInspector.openInEditor.tooltip", {
                        file: _vm.target.file
                      }),
                      expression:
                        "$t('ComponentInspector.openInEditor.tooltip', { file: target.file })"
                    }
                  ],
                  staticClass: "button",
                  on: { click: _vm.openInEditor }
                },
                [
                  _c("VueIcon", { attrs: { icon: "launch" } }),
                  _c("span", [_vm._v("Open in editor")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("template", { slot: "scroll" }, [
        !_vm.hasTarget
          ? _c("section", { staticClass: "notice" }, [
              _c("div", [_vm._v("Select a component instance to inspect.")])
            ])
          : !_vm.target.state || !_vm.target.state.length
          ? _c("div", { staticClass: "notice" }, [
              _c("div", [_vm._v("This instance has no reactive state.")])
            ])
          : _c(
              "section",
              { staticClass: "data" },
              [
                _c("state-inspector", {
                  staticClass: "component-state-inspector",
                  attrs: { state: _vm.filteredState }
                })
              ],
              1
            )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }